import React, { useState } from 'react'
import styled from 'styled-components'
import { Button } from 'primereact/button'

import Text from '../../../ui/Text'
import storage from '../../utils/storage'
import { appInsights } from '../../../lib/track'

const SDiv = styled.div`
    position: fixed;
    bottom: 0px;
    width: 100%;
    z-index: 1000;
    padding: ${({ theme }) => theme.sizing.padding.l};
    background-color: ${({ theme }) => theme.whiteBackground};
    box-shadow: rgba(0, 0, 0, 0.1) 0px -10px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    a {
        text-decoration: underline;
    }

    @media (max-width: 767px) {
        flex-flow: column;
        gap: 20px;
    }
`

const SBtnGroup = styled.div`
    display: flex;
    gap: ${({ theme }) => theme.sizing.margin.m};

    @media (max-width: 767px) {
        margin-left: auto;
        flex-flow: column;
        width: 100%;

        button {
            width: 100%;
        }
    }
`

const cookieConsentName = 'acceptCookieConsent'
const clarityCookieName = '_clck'

const CookieConsentBar = () => {
    const hasClarityCookie = () =>
        document.cookie.split(';').findIndex((nextCookie) => nextCookie.trimStart().startsWith(clarityCookieName)) > -1

    const [cookieSelection, setCookieSelection] = useState<boolean>(() => {
        if (hasClarityCookie()) return true

        return storage.getItem<boolean>(cookieConsentName) === false
    })

    const consentCookies = () => {
        if (!hasClarityCookie()) window.clarity('consent')
        appInsights?.getCookieMgr().setEnabled(true)

        storage.setItem(cookieConsentName, true)
        setCookieSelection(true)
    }

    const closeCookies = () => {
        storage.setItem(cookieConsentName, false)
        setCookieSelection(true)
    }

    return (
        <>
            {!cookieSelection && (
                <SDiv data-testid="cookie-consent-banner">
                    <span>
                        <Text
                            code="msgCookiePolicyInformation"
                            values={{
                                link: {
                                    href: `https://www.chargeamps.com/cookie-policy/`,
                                    target: '_blank',
                                    rel: 'noopener noreferrer',
                                    className: 'blueLink',
                                },
                            }}
                        />
                    </span>
                    <SBtnGroup>
                        <Button
                            type="button"
                            label="Accept"
                            onClick={() => consentCookies()}
                            className="consent-btn"
                            data-testid="cookie-accept-btn"
                            icon="pi pi-check"
                        />
                        <Button
                            type="button"
                            label="Decline"
                            onClick={() => closeCookies()}
                            outlined
                            icon="pi pi-times"
                            data-testid="cookie-decline-btn"
                        />
                    </SBtnGroup>
                </SDiv>
            )}
        </>
    )
}

export default CookieConsentBar
